import { createSlice } from "@reduxjs/toolkit";
import { getDocs, collection } from "firebase/firestore";
import { firestore } from "../../config/fbConfig";

//Initial Value of Slice
const initialState = {
  CanAppliedJobs: [],
  loading: false,
  error: null,
};

//Action of Slice
const CanAppliedJobsSlice = createSlice({
  name: "CanAppliedJobs",
  initialState,
  reducers: {
    setAppliedJobsStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    setAppliedJobsSuccess: (state, action) => {
      state.loading = false;
      state.CanAppliedJobs = action.payload;
    },
    setAppliedJobsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

//Export of Slice
export const {
  setAppliedJobsStart,
  setAppliedJobsSuccess,
  setAppliedJobsFailure,
} = CanAppliedJobsSlice.actions;
export default CanAppliedJobsSlice.reducer;

export const fetchAppliedJobs = (userUUID) => async (dispatch) => {
  try {
    dispatch(setAppliedJobsStart());
    const querySnapshot = await getDocs(
      collection(firestore, "Users", userUUID, "AppliedJobs")
    );

    const AppliedJobs = querySnapshot.docs.map((doc) => ({
      Id: doc.id,
      ...doc.data(),
    }));

    dispatch(setAppliedJobsSuccess(AppliedJobs));
  } catch (error) {
    dispatch(setAppliedJobsFailure(error.message));
  }
};
